import PouchDB from "pouchdb";

export default {
  install(Vue) {},
};
